import getBasePath from '@/common/functions/api-resource';

const basePath = getBasePath('api', 'notas/sellin-devolucao');

const notasActions = {
  listarNotasSellInDevolucaoConsolidado: { methods: 'GET', url: `${basePath}/consolidado?tamanhoPagina={size}&numeroPagina={page}` },
  listarNotasSellInDevolucaoDetalhado: { methods: 'GET', url: `${basePath}/detalhado?tamanhoPagina={size}&numeroPagina={page}` },
};

export default (resource) => resource(`${basePath}`, {}, notasActions);
